import { useApiErrorNotifications } from '@/lib/api/error-notifications'

import { AppToast } from './Toast'

export function ApiErrorToastHost() {
  const current = useApiErrorNotifications((state) => state.queue[0])
  const dismiss = useApiErrorNotifications((state) => state.dismiss)
  return (
    <AppToast
      key={current?.id ?? 'closed'}
      open={Boolean(current)}
      title={current?.message ?? ''}
      description=""
      variant="error"
      compact
      durationMs={6000}
      onClose={() => {
        if (current) dismiss(current.id)
      }}
    />
  )
}
